import { mediaData } from '@/mocks/home-data';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Entertainment%20news%20video%20thumbnail%20with%20dramatic%20warm%20lighting%2C%20abstract%20celebrity%20silhouette%2C%20red%20and%20gold%20accent%2C%20cinematic%20composition%2C%20editorial%20news%20aesthetic%2C%20modern%20media%20production%20style%2C%20soft%20bokeh%20background&width=800&height=450&seq=media-thumb-1-bagua&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Breaking%20news%20video%20thumbnail%20with%20warm%20amber%20tones%2C%20abstract%20paparazzi%20scene%2C%20dramatic%20lighting%2C%20magazine%20collage%20aesthetic%2C%20entertainment%20journalism%20style%2C%20golden%20hour%20glow&width=800&height=450&seq=media-thumb-2-bagua&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Social%20media%20entertainment%20video%20thumbnail%20with%20warm%20crimson%20and%20gold%20accents%2C%20abstract%20crowd%20scene%2C%20festival%20vibe%2C%20editorial%20photography%20style%2C%20modern%20clean%20composition%2C%20soft%20dramatic%20lighting&width=800&height=450&seq=media-thumb-3-bagua&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            瓜料视频
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8">
          热门八卦视频解读，三分钟吃透一个大瓜
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((item, idx) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer"
            >
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={mediaImages[idx]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
                    <i className="ri-play-fill text-2xl text-primary-500 ml-1"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-3 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-1.5 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}